export const TYPE_INCLUSIVE_STRING = 'inclusive'
export const TYPE_EXACT_STRING = 'exact'
